var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "top-c" }, [
        _vm._v("首页装修-" + _vm._s(_vm.pageName)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "left-box" }, [
          _c(
            "div",
            {
              staticClass: "have-bg",
              style: {
                "background-image":
                  "url(" + _vm.backgroundConfig.backgroundUrl + ")",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "left-son",
                  style: {
                    background:
                      "linear-gradient(to bottom, transparent 0%, " +
                      _vm.backgroundConfig.color +
                      " " +
                      30 +
                      "%)",
                  },
                },
                _vm._l(_vm.tableData, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "my-over-div",
                      style: {
                        paddingLeft: item.horizontalMargin === 1 ? "6px" : 0,
                        paddingRight: item.horizontalMargin === 1 ? "6px" : 0,
                        marginTop: item.topMargin === 1 ? "6px" : 0,
                      },
                      on: {
                        mouseover: function ($event) {
                          return _vm.bothMouseOver(item, index)
                        },
                      },
                    },
                    [
                      item.boole
                        ? _c(
                            "div",
                            {
                              staticClass: "move-box",
                              on: {
                                mouseleave: function ($event) {
                                  return _vm.bothMouseLeave(item)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "primary",
                                      icon: "el-icon-edit",
                                      size: "mini",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.bothClick(item)
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "margin-top": "10px" } },
                                    [_vm._v("模块ID:" + _vm._s(item.moduleId))]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.status === 1
                        ? _c(item.componentCode, {
                            key: item.timestamp,
                            tag: "component",
                            attrs: { "item-detail": item },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right-box" }, [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
                "margin-bottom": "20px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "align-items": "center",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "18px",
                        "font-weight": "bold",
                        color: "#282828",
                        "margin-right": "10px",
                      },
                    },
                    [_vm._v("模块编辑")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.addModule()
                        },
                      },
                    },
                    [_vm._v("新增模块+")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.goBack()
                        },
                      },
                    },
                    [_vm._v("返回上一页")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "align-items": "center",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "success" },
                      on: { click: _vm.saveBgColor },
                    },
                    [
                      _vm._v("编辑首页背景"),
                      _c("i", { staticClass: "el-icon-right" }),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "my_table_name" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    "element-loading-text": "拼命加载中",
                    "element-loading-spinner": "el-icon-loading",
                    "element-loading-background": "rgba(0, 0, 0, 0.8)",
                    "row-key": "id",
                    "header-cell-style": { "text-align": "center" },
                    "cell-style": { "text-align": "center" },
                    data: _vm.tableData,
                    border: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "模块ID", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.moduleId))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "模块名称", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_c("span", [_vm._v(_vm._s(scope.row.name))])]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "备注信息", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.remark))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "上边距", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              on: {
                                change: function ($event) {
                                  return _vm.allChange(scope.row, "topMargin")
                                },
                              },
                              model: {
                                value: scope.row.topMargin,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "topMargin", $$v)
                                },
                                expression: "scope.row.topMargin",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "左右边距", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              on: {
                                change: function ($event) {
                                  return _vm.allChange(
                                    scope.row,
                                    "horizontalMargin"
                                  )
                                },
                              },
                              model: {
                                value: scope.row.horizontalMargin,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "horizontalMargin", $$v)
                                },
                                expression: "scope.row.horizontalMargin",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "展示状态", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              on: {
                                change: function ($event) {
                                  return _vm.allChange(scope.row, "status")
                                },
                              },
                              model: {
                                value: scope.row.status,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "status", $$v)
                                },
                                expression: "scope.row.status",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              scope.row.componentCode === "shopList" ||
                              scope.row.componentCode === "topSearch"
                                ? _c("img", {
                                    staticClass: "icon_box",
                                    attrs: {
                                      src: require("@/assets/r_notMove.png"),
                                      alt: "",
                                    },
                                  })
                                : _c("img", {
                                    staticClass: "icon_box dg_div",
                                    attrs: {
                                      src: require("@/assets/r_move.png"),
                                      alt: "",
                                    },
                                  }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "icon_box ",
                                staticStyle: { margin: "0 10px" },
                                attrs: {
                                  src: require("@/assets/r_detail.png"),
                                  alt: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.moduleUpdate(scope.row)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "icon_box",
                                attrs: {
                                  src: require("@/assets/r_del.png"),
                                  alt: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.del(scope.row)
                                  },
                                },
                              }),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("pageConfigPop", {
        ref: "pageConfigPop",
        attrs: { "page-id": _vm.pageId, type: 1 },
        on: { refresh: _vm.findModule },
      }),
      _vm._v(" "),
      _c("addModule", {
        ref: "addModule",
        attrs: { "page-id": _vm.pageId },
        on: { refresh: _vm.findModule },
      }),
      _vm._v(" "),
      _c("bannerListPop", {
        ref: "bannerListPop",
        on: { refresh: _vm.refreshModule },
      }),
      _vm._v(" "),
      _c("marqueePop", { ref: "marqueePop" }),
      _vm._v(" "),
      _c("earningsReportPop", { ref: "earningsReportPop" }),
      _vm._v(" "),
      _c("collectionPop", { ref: "collectionPop" }),
      _vm._v(" "),
      _c("hotPicksPop", { ref: "hotPicksPop" }),
      _vm._v(" "),
      _c("floatingWindowPop", { ref: "floatingWindowPop" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }